import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

const CELL_HEIGHT = 63 / 8;

export const sectionHeaderRow: SxStyle = {
  cursor: 'pointer',
};

// Only the opened section's header row is shaded (see below); the expanded
// feature rows keep the default white background.
// The open-state background lives on the cells, not the row: a `<tr>`
// background is unreliable in MUI tables (cells paint over it), so the row
// would stay white while the collapse body shows grey.50.
interface HeaderCellState {
  open: boolean;
  // The last collapsed section's header is the table's bottom row: it drops its
  // own bottom border so the table's rounded bottom border is the only edge
  // (otherwise the two stack into a doubled "thick" line).
  atBottom: boolean;
}

export const sectionHeaderCell: SxStyleFunc<HeaderCellState> = ({
  open,
  atBottom,
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  pl: 2,
  pr: 1,
  py: 0,
  height: (p) => p.spacing(CELL_HEIGHT),
  borderRight: '1px solid',
  borderBottom: atBottom ? 0 : '1px solid',
  borderColor: 'divider',
  bgcolor: open ? 'grey.50' : 'transparent',
});

export const sectionHeaderValueCell: SxStyleFunc<HeaderCellState> = ({
  open,
  atBottom,
}) => ({
  py: 0,
  height: (p) => p.spacing(CELL_HEIGHT),
  borderRight: '1px solid',
  borderBottom: atBottom ? 0 : '1px solid',
  borderColor: 'divider',
  '&:last-of-type': { borderRight: 0 },
  bgcolor: open ? 'grey.50' : 'transparent',
});

// When the last section is expanded, its inner table's last row is the table's
// bottom; drop that row's bottom border so it doesn't double the table border.
export const collapseInnerLast: SxStyle = {
  '& tbody tr:last-child td': { borderBottom: 0 },
};

export const coverageStack: SxStyle = {
  alignItems: 'center',
  justifyContent: 'center',
  gap: 0.5,
};

export const collapseButton: SxStyle = {
  p: 0,
};

export const collapsibleWrapperCell: SxStyle = {
  p: '0 !important',
  borderBottom: 0,
};

export const featureRow: SxStyle = {};

export const featureNameCell: SxStyle = {
  pl: 5,
  pr: 1,
  py: 0,
  height: (p) => p.spacing(CELL_HEIGHT),
  borderRight: '1px solid',
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const featureValueCell: SxStyle = {
  py: 0,
  height: (p) => p.spacing(CELL_HEIGHT),
  width: 269,
  minWidth: 269,
  borderRight: '1px solid',
  borderBottom: '1px solid',
  borderColor: 'divider',
  '&:last-of-type': { borderRight: 0 },
};
